import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import moment from 'moment';
import { useEffect, useState } from 'react';
import useDashboardSelection from '../../hooks/UseDashboardSelection';
import { IBuilding } from '../../models/dashboard';
import DashboardHeader from '../Dashboard/DashboardHeader';
import Spinner from '../Spinner/Spinner';


interface DataGridRow {
    id : string,
    localName : string,
    username : string,
    time : number
    date : string,
}

const dateFormat = "DD MMM, YYYY h:mma";

const columns: GridColDef[] = [
    { field: 'localName', headerName: 'Local', minWidth : 250 },
    { field: 'username', headerName: 'Employee', minWidth : 250 },
    { field: 'date',headerName: 'Start',type: 'string', minWidth : 300 },
    {
        field: 'endDate',
        headerName: 'End',
        type : 'string',
        sortable: true,
        width: 300,
        valueGetter: (params: GridValueGetterParams) => params.row.date &&
          convertToEndDate(params.row.date,params.row.time),
      },
    { field: 'time',headerName: 'Cleaning Time (minutes)',type: 'number', minWidth : 250 },
];

const createRows = (buildings : IBuilding[] | undefined) => {
    const rows : DataGridRow[] = [];
    buildings?.forEach( (building) =>{
        building.locals.forEach(local => {
            local.scans.forEach(scan => {
                const idHash = `${local.id}${scan.time}${scan.username}_${Math.random()*100}`;
                rows.push({id : idHash,localName:local.name, time: scan.time, username : scan.username, date: moment(scan.date).local().format(dateFormat)})
            });
        });
    })

    return rows;
}

const DashboardDataTable = () => {
    const rowsPerPage = [25,50, 100];
    const [rows, setRows] = useState<any>();
    const [pageSize, setPageSize] = useState<number>(rowsPerPage[0]);
    const {start,setStart,end,setEnd,buildingId,setBuildingId,buildings,buildingSelections, serverMessage,isLoading} = useDashboardSelection();


    useEffect( () => {
       setRows(createRows(buildings))
    },[buildings])

    return (
        <>
            <header>
                <DashboardHeader
                    key={buildingId} 
                    buildingId={buildingId} 
                    buildingSelections={buildingSelections} 
                    setBuildingId={setBuildingId} 
                    setStart={setStart} 
                    setEnd={setEnd} 
                    start={start} end={end}
                    />
                {serverMessage && <p>{serverMessage}</p>}
            </header>
            {
                rows && !isLoading ? 
                <div style={{ height: "75vh", width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={pageSize}
                            rowsPerPageOptions={rowsPerPage}
                            onPageSizeChange = { (value) => setPageSize(value)}
                        />
                </div> : <Spinner/>
            }
        </> 
        );
}

export default DashboardDataTable;

function convertToEndDate(dateJson: string, time: number) {
    return moment(dateJson,dateFormat).add(time, "minutes").local().format(dateFormat);
}
